// src/config/googleMaps.js
export const GOOGLE_MAPS_VERSION = '3.64';
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry', 'drawing', 'visualization'];
export const GOOGLE_MAPS_ID = 'google-map-script';
